<template>
  <div class="flex flex-col gap-x-2 gap-y-4 md:flex-row">
    <slot />
  </div>
</template>
